<!--<div class="text-center font-bold text-2xl m-4">各區中心</div>-->

<div class="max-height">
  <app-map-widget></app-map-widget>
</div>
